'use client';

import { FC } from 'react';

import { Heading } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { ArticleCardData } from '@telialt/core-cms-content/src/components/ArticleCard/model';

import { ArticleCardsListFactory } from '../Common/ArticleCardsList/ArticleCardsListFactory';
import { PaginationQuery } from '../Common/ArticleCardsList/model';
import { CardsListWrapper, PageHeadingWrapper } from './BlogTagPage.styles';

type Props = { pageTitle: string; articles: ArticleCardData[]; totalItems: number } & PaginationQuery;

export const TagArticleCardsList: FC<Props> = ({ pageTitle, ...controls }) => {
    const { t } = useTranslations();
    const ArticleCardsList = ArticleCardsListFactory(controls);
    const { totalItems } = controls;

    return (
        <>
            <PageHeadingWrapper>
                <Heading tag="h1" variant="title-500">
                    {pageTitle}
                </Heading>
                <ArticleCardsList.SortSelector />
            </PageHeadingWrapper>
            {!!totalItems && (
                <CardsListWrapper>
                    <ArticleCardsList.CardsList data-section-name={pageTitle} />
                </CardsListWrapper>
            )}
            <ArticleCardsList.NotFound description={t['blog.articles_not_found.for_tag']} />
        </>
    );
};
